import Vue from 'vue'
import FormErrors from './FormErrors'
import { toFormData, unwrapFunction } from '@utils'

const reservedAttributes = [
    '_initialData', '_submitCallback', 'errors', 'busy', 'successful',
]

export default class Form {

    constructor (initialData = {}, submitCallback = null) {
        this._initialData = initialData
        this._submitCallback = submitCallback
        this.errors = new FormErrors()
        this.reset()
    }

    reset () {
        this.busy = false
        this.successful = false
        this.errors.clear()
        this.deleteUnreservedAttributes()
        this.setInitialData(this._initialData)
    }

    setInitialData (data) {
        this._initialData = data
        this.setData(unwrapFunction(this._initialData))
    }

    setData (data) {
        _.forEach(data, (value, key) => {
            Vue.set(this, key, value)
        })
    }

    deleteUnreservedAttributes () {
        _.forEach(this, (value, key) => {
            if (! reservedAttributes.includes(key)) {
                Vue.delete(this, key)
            }
        })
    }

    async submit (...args) {
        if (this.busy || ! this._submitCallback) {
            return
        }
        this.beforeStart()
        const result = await this._submitCallback(this, ...args).catch(error => {
            this.onFailure(error)
            throw error
        })
        this.onSuccess()
        return result
    }

    export () {
        return _.omit({ ...this }, reservedAttributes)
    }

    toFormData (...args) {
        return toFormData(this.export(), ...args)
    }

    beforeStart () {
        this.busy = true
        this.successful = false
        this.errors.clear()
    }

    onSuccess () {
        this.busy = false
        this.successful = true
    }

    onFailure (error) {
        this.busy = false
        if (error.response && error.response.data) {
            const { errors, message } = error.response.data
            this.setErrors(errors, message)
        }
    }

    setErrors (errors, message) {
        this.errors.set(errors, message)
    }
}
